module.exports = __webpack_public_path__ + "static/object-9-6921549d2be3219d968cb25ed1b3cd78.png";